<template>
  <button
    class="text-blue-500 text-sm flex gap-1 items-center font-semibold"
    aria-label="show fid info"
    data-gtm-action="show fid info"
    @click.prevent="handleClick"
  >
    what? <svg-icon name="info" class="h-3 w-3" />
  </button>
</template>

<script setup lang="ts">
import { useThemeStore } from '@/stores'
import type { MediaImage } from '@/types/shopify'

const FidWhatModal = () => import('./fid-what-modal.vue')

const { modal } = useThemeStore()
const props = defineProps<{
  image?: MediaImage
  src?: string
  width?: number | string
  height?: number | string
  alt: string
}>()

const handleClick = () => modal.open(FidWhatModal, props)
</script>
